/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2IconEditFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2IconEditFilled({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2IconEditFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2IconEditFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-Z2wEOnW': alignSelf,'--mt-2-Z2wEOnW': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2wEOnW': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2wEOnW': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2wEOnW': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2wEOnW': opacity,'--w-10-Z2wEOnW': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2wEOnW': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2wEOnW': fill,'--a-7-Z2wEOnW': isAnimated ? animation : "none",'--sd-8-Z2wEOnW': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2wEOnW': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2IconEditFilled.SvgPath"
  data-view-path={viewPath}
 d="M9.184 0a1.286 1.286 0 00-.917.385L1.207 7.41a.429.429 0 00-.111.188l-1.08 3.857a.429.429 0 00.528.528l3.857-1.08a.43.43 0 00.188-.11l7.026-7.06.002-.002a1.285 1.285 0 000-1.823l-.002-.001L10.101.385A1.284 1.284 0 009.184 0z"
 style={{'--f-12-Z2wEOnW': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}